import EfCardsA from '@elem/ui/ef-cards-a';
import EfTitle from '@elem/ui/ef-title';
import { useRouter } from 'next/router';
import EfSectionLR from '@elem/ui/ef-section-l-r';
import css from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('rapid.SectionD');
    const { locale = 'us' } = useRouter();
    const IS_NA = ['us', 'ca'].includes(locale);
    const IS_EU = ['eu', 'uk', 'de', 'fr', 'es', 'it', 'nl'].includes(locale);
    const cards = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1729600943597/pc.jpg',
            title: t('a_title'),
            desc: t.rich('a_desc', {
                sup: (text: string) => <sup className="sup">{text}</sup>,
            }),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1729600951681/m.jpg',
            title: t('b_title'),
            desc: t('b_desc'),
        },
    ];
    return (
        <div className={css.comp}>
            <EfTitle>{t('title')}</EfTitle>
            {['us', 'ca', 'jp'].includes(locale) && <EfCardsA list={cards} />}
            {['eu', 'uk', 'de', 'fr', 'es', 'it', 'kr', 'nl'].includes(locale) && (
                <EfSectionLR
                    pc="https://websiteoss.ecoflow.com/upload/image/1724914041674/always_ready.jpg"
                    desc={t.rich('desc', {
                        sup: (text: string) => <sup className="sup">{text}</sup>,
                    })}
                />
            )}
        </div>
    );
}
